module.exports = __webpack_public_path__ + "img/search-icon.c12d2102.svg";